import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  TenantResolverService,
  AuthguardService,
} from '@fitness-force/shared';
import { PipelineComponent } from './pipeline/pipeline.component';
import { SalesCalendarComponent } from './sales-calendar/sales-calendar.component';
import { TaskListComponent } from './task-list/task-list.component';
import { ProspectListComponent } from './prospect-list/prospect-list.component';
import { TrialListComponent } from './trial-list/trial-list.component';
import { InboxComponent } from '../client-management/inbox/inbox.component';
import { ContactsListComponent } from './contacts-list/contacts-list.component';


const routes: Routes = [

      {
        path: '',
        redirectTo: 'sales-pipeline',
        pathMatch: 'full',
      },
      {
        path: 'sales-pipeline',
        component: PipelineComponent,
        canActivate: [AuthguardService],
        resolve: { data: TenantResolverService },
        data: {
          title:"Sales Pipeline"
        },
      },
      {
        path: 'sales-calendar',
        component: SalesCalendarComponent,
        canActivate: [AuthguardService],
        resolve: { data: TenantResolverService },
        data: {
          breadcrumb: 'Sales Calendar',
          title:"Sales Calendar"
        },
      },
      {
        path: 'task-list',
        component: TaskListComponent,
        canActivate: [AuthguardService],
        resolve: { data: TenantResolverService },
        data: {
          breadcrumb: 'Task List',
          title:"Task List"
        },
      },
      {
        path: 'prospect-list',
        component: ProspectListComponent,
        canActivate: [AuthguardService],
        resolve: { data: TenantResolverService },
        data: {
          breadcrumb: 'Prospect List',
          title:"Prospect List"
        },
      },
      {
        path: 'trial-list',
        component: TrialListComponent,
        canActivate: [AuthguardService],
        resolve: { data: TenantResolverService },
        data: {
          breadcrumb: 'Trial List',
          title:"Trial List"
        },
      },
      {
        path: 'contacts-list',
        component: ContactsListComponent,
        canActivate: [AuthguardService],
        resolve: { data: TenantResolverService },
        data: {
          breadcrumb: 'Contacts List',
          title:"Contacts List"
        },
      },
      {
        path: 'inbox',
        component: InboxComponent,
        canActivate: [AuthguardService],
        resolve: { data: TenantResolverService },
        data: {
          breadcrumb: '',
          title: 'Inbox'
        },

      },
      {
        path: 'inbox/:id',
        component: InboxComponent,
        canActivate: [AuthguardService],
        resolve: { data: TenantResolverService },
        data: {
          breadcrumb: '',
          title: 'Inbox'
        },
      }
      // {
      //   path: 'task-list', loadChildren: () => import('./task-list/task-list.component').then(a => a.TaskListComponentModule), data: { isTenant: false }
      // },


      // {
      //   path: 'prospect-list', loadChildren: () => import('./prospect-list/prospect-list.component').then(a => a.ProspectListComponent), data: { isTenant: false }
      // },
      // {
      //   path: 'sales-calendar', loadChildren: () => import('./sales-calendar/sales-calendar.component').then(a => a.SalesCalendarComponentModule), data: { isTenant: false }
      // }
    ];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class crmRoutingModule {}